import { httpClient } from '@/services/http/httpClient'

export type UpdateTaskRequest = {
  id: string
  title?: string
  projectId?: string
  description?: string
  startDate?: string | null
  endDate?: string | null
  responsableId?: string
  completed?: boolean
  sequence?: number
}

export async function updateTask({
  id,
  title,
  description,
  startDate,
  endDate,
  responsableId,
  completed,
  projectId,
  sequence,
}: UpdateTaskRequest) {
  const payload: Record<string, unknown> = {
    title,
    description,
    responsableId,
    completed,
    projectId,
    sequence,
  }

  if (startDate !== undefined) {
    payload.startDate = startDate
  }
  if (endDate !== undefined) {
    payload.endDate = endDate
  }

  await httpClient.put(`/projects/project-tasks/${projectId}/${id}`, payload)
}
